/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { createContext, useContext, useEffect, useState } from 'react';

import {
  NotificationsResponse,
  getNotifications,
  putNotificationsRead,
} from 'services/mainNotificationsServices';

interface NotificationsProps {
  quantityNotifications: number;
  notifications: NotificationsResponse[];
  handleNotificationIsRead: (idNotification: string | number) => void;
  loadNotifications: () => Promise<void>;
}

const NotificationsContext = createContext<NotificationsProps>(
  {} as NotificationsProps
);

// @ts-expect-error
export const NotificationsContextProvider = ({ children }) => {
  const [quantityNotifications, setQuantityNotifications] = useState<number>(0);
  const [notifications, setNotifications] = useState<NotificationsResponse[]>(
    []
  );

  async function loadNotifications() {
    const response = await getNotifications();
    const notificationsUnRead = response.filter(
      (notification) => notification.status !== 'READ'
    );
    setQuantityNotifications(notificationsUnRead?.length);
    setNotifications(notificationsUnRead);
  }

  useEffect(() => {
    loadNotifications();
  }, []);

  async function handleNotificationIsRead(
    idNotification: number | string
  ): Promise<void> {
    await putNotificationsRead(idNotification);
    setTimeout(() => {
      loadNotifications();
    }, 500);
  }

  return (
    <NotificationsContext.Provider
      value={{
        quantityNotifications,
        handleNotificationIsRead,
        loadNotifications,
        notifications,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotificationContext = () => useContext(NotificationsContext);
